<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit"
             subtitulo="Cadastrar nova etapa da construção" col-md="col-md-5" offset="3">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.etapa"
                    inputId="etapa"
                    :options="etapas"
                    optionLabel="descricao"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('etapa')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="etapa">
                  <strong>Etapa:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_inicio" v-model="dado.data_inicio" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataInicio" dateFormat="dd/mm/yyyy"/>
                <label for="data_inicio"><strong>Data de Inicio: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_termino_previsao" v-model="dado.data_termino_previsao" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataTerminoPrevisao"
                            dateFormat="dd/mm/yyyy"/>
                <label for="data_termino_previsao"><strong>Previsão Término: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_termino" v-model="dado.data_termino" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataTermino" dateFormat="dd/mm/yyyy"/>
                <label for="data_termino"><strong>Data Término: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="observacao" v-model="dado.observacao" size="small" style="width: 100%"/>
                <label for="observacao"><strong>Observação: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import moment from 'moment';
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, denormalizeDates} from "../../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "CadastrarConstrucaoEtapas",
  components: {
    BaseModal,
  },
  props: {
    construcaoId: Number,
    construcaoDescricao: String,
  },
  data() {
    return {
      etapas: [],
      dado: {
        construcao: this.construcaoId,
        etapa: "",
        data_inicio: null,
        data_termino_previsao: null,
        data_termino: null,
        observacao: "",
      },
      campoVazio: [],
    }
  },
  emits: ["fechar", "atualizarLista"],
  methods: {
    async getEtapas() {
      const resultado = await apiRequest("GET", `${apiUrl.etapas.createList}?status=A`);
      if (resultado.success) {
        this.etapas = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitIncluirForm() {
      denormalizeDates(this.dado, ['data_inicio', 'data_termino', 'data_termino_previsao']);
      const resultado = await apiRequest("POST", apiUrl.construcoes.etapaCreateList(this.construcaoId), this.dado);
      if (resultado.success) {
        ['data_inicio', 'data_termino', 'data_termino_previsao'].forEach(field => {
          if (resultado.data[field] != null) {
            resultado.data[field] = moment(resultado.data[field]).format('DD/MM/YYYY')
          }
        });
        this.$emit("atualizarLista", resultado.data);
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  watch: {
    calculoPrevisaoDeps() {
      if (!this.dado.data_inicio || !this.dado.etapa) return;

      const etapa = this.etapas.find(e => e.id === this.dado.etapa);
      if (!etapa) return;

      const dias = Number(etapa.tempo);

      const dataPrevisao = new Date(this.dado.data_inicio);
      dataPrevisao.setDate(dataPrevisao.getDate() + dias);

      this.dado.data_termino_previsao = dataPrevisao;
    }
  },
  computed: {
    calculoPrevisaoDeps() {
      return {
        data_inicio: this.dado.data_inicio,
        etapa: this.dado.etapa
      };
    }
  },
  mounted() {
    this.getEtapas();
    Inputmask("99/99/9999").mask(this.$refs.dataInicio.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataTermino.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataTerminoPrevisao.$el.querySelector("input"));
  }
}
</script>
